export function filterArrayByAllowedValues<T>(
  input: readonly T[],
  allowed: readonly T[],
): T[] {
  return input.filter(value => allowed.includes(value));
}
